
// 单例
export const getSingle = function(fn) {
    let instance = null

    return (...args) => {
        if (!instance) {
            instance = fn(...args)
        }

        return instance
    }
}
